// extracted by mini-css-extract-plugin
export default {"skeleton-field":"SkeletonField_skeleton-field__bUALi","shine-fields":"SkeletonField_shine-fields__ErNbJ"};